function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/directional/arrow-left",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c5evr4brta"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/directional/arrow-left (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/directional/arrow-left (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/directional/arrow-left",
    style: {
      clipPath: "url(#c5evr4brta)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/directional/arrow-left (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/directional/arrow-left (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.187 7.453H13.9L5.693.328A.186.186 0 0 1 5.815 0h2.074a.376.376 0 0 1 .246.091l8.857 7.685a.749.749 0 0 1 0 1.132l-8.908 7.733a.185.185 0 0 1-.122.047H5.817a.187.187 0 0 1-.122-.328L13.9 9.234H.187A.188.188 0 0 1 0 9.047V7.641a.188.188 0 0 1 .187-.188z",
    transform: "translate(3.375 3.656)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckout);
export default __webpack_public_path__ + "static/media/checkout.d8bdc8ae929c39e42c49757f4a68e6e7.svg";
export { ForwardRef as ReactComponent };